import React, { Component } from "react";
import Head from "next/head";
import NProgress from "components/NProgress";
import ReactPixel from 'react-facebook-pixel';
// import TagManager from 'react-gtm-module';
import ClapprPlayer from '../components/Clappr/ClapprPlayer';

// const tagManagerArgs = {
//     gtmId: 'GTM-WCJSTPT',
// }

class ClapprTest extends Component {
  constructor(props){
    super(props);
    this.state = {
       ssrDone: false,
    };
    this.onPlay = this.onPlay.bind(this);
    this.onPause = this.onPause.bind(this);
    this.onEnded = this.onEnded.bind(this);
    this.onVideoLoad = this.onVideoLoad.bind(this);
    this.onReady = this.onReady.bind(this);
  }  
  onPlay() {
    console.log('onPlay');
  }
  onPause() {
    console.log('onPause');
  }
  onVideoLoad() {
    console.log('onVideoLoad');
  }
  onEnded() {
    console.log('onEnded');
  }
  onReady() {
    console.log('onReady');
  }

  render() {
    const ssrDone = this.state.ssrDone;
    return (
      <div>
        <Head>
          <title>Clappr Test</title>
        </Head>
        <NProgress />
        <div>
          <h1>Hello World</h1>
          {
          ssrDone &&
          <ClapprPlayer 
            id="test-clappr-player" 
            width="100%"
            height="360"
            autoPlay={true}
            poster="https://duwun.sgp1.cdn.digitaloceanspaces.com/113873/conversions/dontPGaZdK-thumb.jpg"
            source="https://dmbf27t3xv7sf.cloudfront.net/converted/iG22oB60X2/416.m3u8"
            onPlay={this.onPlay}
            onPause={this.onPause}
            onEnded={this.onEnded}
            onVideoLoad={this.onVideoLoad}
            onReady={this.onReady}
          />
          }
        </div>
      </div>
    );
  }
    componentDidMount () {
        // ************ start facebook pixel ***********

        if (!window.PX_INITIALIZED) {
            const advancedMatching = { em: '' }; // optional, more info: https://developers.facebook.com/docs/facebook-pixel/pixel-with-ads/conversion-tracking#advanced_match
            const options = {
                autoConfig: true, 	// set pixel's autoConfig
                debug: false, 		// enable logs
            };
            ReactPixel.init('548709379041005', advancedMatching, options);
            // ReactPixel.init('355678948310337', advancedMatching, options);
            window.PX_INITIALIZED = true
        }
        // ReactPixel.pageView(); 					// For tracking page view
        //  ReactPixel.track( event, data ) 		// For tracking default events, more info about events and data https://developers.facebook.com/docs/ads-for-websites/pixel-events/v2.9
        //  ReactPixel.trackCustom( event, data ) 	// For tracking custom events
        // ************ end facebook pixel ***********
        this.setState({
            ssrDone: true,
        });
    }
  
    componentDidUpdate(previousProps, previousState){
        // TagManager.dataLayer(tagManagerArgs)
    }
}

export default ClapprTest;